/**
 * @module app.bdc.list.deleteOrderCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function DeleteOrderCtrl($scope, $uibModalInstance, $log) {
        var self = {};

        self.delete = function() {
            $uibModalInstance.close(true);
        };

        self.doNotDelete = function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    DeleteOrderCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular
        .module('app.bdc.list.deleteOrderCtrl', ['ui.bootstrap.modal'])
        .controller('DeleteOrderCtrl', DeleteOrderCtrl);
});
